exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spn-create {\r\n  margin-left: 15px;\r\n  vertical-align: middle;\r\n}\r\n.btn-create-icon {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-align: center;\r\n      align-items: center;\r\n  gap: 4px;\r\n  padding: 0 16px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/button/button-panel-header/button-panel-header.component.css
// module id = ../../../../../src/app/shared/button/button-panel-header/button-panel-header.component.css
// module chunks = main